import initialStateTemplate from './initial-state';
import { createReducer } from './reducer-creator';

function setPaquetesOriginal(initialState, action) {
  const nuevoOriginal = initialState.original.concat(action.payload);
  return {
    ...initialState,
    original: nuevoOriginal,
  };
}
function setPaquetesFiltrados(initialState, action) {
  return {
    ...initialState,
    filtrados: action.payload,
  };
}
function setPackagesDestinationAndOrigin(initialState, action) {
  return {
    ...initialState,
    ciudadDestino: action.payload.destino,
    ciudadOrigen: action.payload.origen,
  };
}

function setPackageDetails(intialState, action) {
  return {
    ...intialState,
    details: {
      ...action.payload,
    },
  };
}

export default createReducer(initialStateTemplate.packages, {
  SET_PACKAGES_FILTRADOS: setPaquetesFiltrados,
  SET_PACKAGES_ORIGINAL: setPaquetesOriginal,
  SET_PACKAGES_DESTINATION_AND_ORIGIN: setPackagesDestinationAndOrigin,
  SET_PACKAGE_DETAILS: setPackageDetails,
});
